import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon, IonImg, IonItem, IonLabel, IonThumbnail } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { stopwatchOutline } from 'ionicons/icons';

addIcons({ stopwatchOutline });

@Component({
  selector: 'crowdctrl-session-item',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel, IonThumbnail, IonIcon, IonImg],
  templateUrl: './session-item.component.html',
  styleUrl: './session-item.component.css',
})
export class SessionItemComponent implements OnChanges {
  @Input() sessionName!: string;
  @Input() status?: string;
  @Input() thumbnailUrl?: string | null;
  @Input() button = false;
  @Input() detail = false;
  @Input() lines?: string;
  @Output() click = new EventEmitter<void>();
  thumbnailLoadFailed = false;

  ngOnChanges(changes: SimpleChanges): void {
    if ('thumbnailUrl' in changes) {
      this.thumbnailLoadFailed = false;
    }
  }

  get showThumbnailImage(): boolean {
    return !!this.thumbnailUrl && !this.thumbnailLoadFailed;
  }

  onThumbnailError(): void {
    this.thumbnailLoadFailed = true;
  }

  onItemClick(): void {
    this.click.emit();
  }
}
